import { render, staticRenderFns } from "./ActivitieProducts.vue?vue&type=template&id=fb871fec&scoped=true&lang=pug&"
import script from "./ActivitieProducts.vue?vue&type=script&lang=js&"
export * from "./ActivitieProducts.vue?vue&type=script&lang=js&"
import style0 from "./ActivitieProducts.vue?vue&type=style&index=0&id=fb871fec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb871fec",
  null
  
)

export default component.exports